import React, { useReducer } from 'react';
import Context from './Context.js';
import jobsReducer from './jobsReducer';

const Provider = ({ children }) => {
	const initialState = [];

	const localState = JSON.parse(localStorage.getItem('jobs'));
	const [jobs, dispatch] = useReducer(jobsReducer, localState || initialState);

	return (
		<Context.Provider
			value={{
				jobs,
				dispatch,
			}}
		>
			{children}
		</Context.Provider>
	);
};

export default Provider;
